import { getMeasureMarkers } from './internal/utils';

export function startTimer(event: string) {
  const { startEvent } = getMeasureMarkers(event);
  performance.mark(startEvent);
}
